import { useAtomValue, useSetAtom } from "jotai";
import { canv } from "@/canv/global";
import { ArrowIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { HStack } from "@/shared/ui/Stack";
import type { DocumentTurnPageOption, widgetOption } from "@/widgetMenu/widgetMenu";
import { turnPage } from "../../lib/turnPage";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./DocumentTurnPage.module.css";
import { PageInput } from "./PageInput";

export function DocumentTurnPage() {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("documentTurnPage")) as
        | widgetOption<DocumentTurnPageOption>[]
        | undefined;

    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const firstOption = options?.[0];
    if (!firstOption) {
        return null;
    }
    const { currentPageNumber, totalPages } = firstOption.value;

    const handlePrevPageButtonClick = () => {
        const pageNumber = currentPageNumber - 1;

        if (pageNumber < 1) {
            return;
        }

        turnPage(pageNumber, canv);

        setWidgetMenuOptions((prevMap) => {
            const newMap = new Map(prevMap);
            const options = prevMap.get(
                "documentTurnPage",
            ) as widgetOption<DocumentTurnPageOption>[];
            options[0].value.currentPageNumber = pageNumber;
            newMap.set("documentTurnPage", options);

            return newMap;
        });
    };

    const handleNextPageButtonClick = () => {
        const pageNumber = currentPageNumber + 1;

        if (pageNumber > totalPages) {
            return;
        }

        turnPage(pageNumber, canv);

        setWidgetMenuOptions((prevMap) => {
            const newMap = new Map(prevMap);
            const options = prevMap.get(
                "documentTurnPage",
            ) as widgetOption<DocumentTurnPageOption>[];
            options[0].value.currentPageNumber = pageNumber;
            newMap.set("documentTurnPage", options);

            return newMap;
        });
    };

    return (
        <HStack gap={2}>
            <MenuButton onClick={handlePrevPageButtonClick}>
                <ArrowIcon style={{ transform: "rotate(270deg)" }} />
            </MenuButton>
            {options && <PageInput options={options} />}
            <span className={styles.divider}>/</span>
            <span className={styles.totalPages}>{totalPages}</span>
            <MenuButton onClick={handleNextPageButtonClick}>
                <ArrowIcon style={{ transform: "rotate(90deg)" }} />
            </MenuButton>
        </HStack>
    );
}
